import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import logo from 'assets/image/header__logo.svg';

interface HeaderProps {
  pageTitle?: string;
}

const Header: React.FC<HeaderProps> = ({ pageTitle }) => {
  return (
    <Container fluid>
      <div className="p-3">
        <img src={logo} alt="" />
      </div>
      <Navbar className="bg-primary">
        <div className="mx-auto text-light fw-bold fs-4">{pageTitle}</div>
      </Navbar>
    </Container>
  );
};

export default Header;
